import React from 'react';
import classes from './block1.module.css';
import img1 from '../../images/img1.png';
import img2 from '../../images/img2.png';
import img3 from '../../images/img3.png';
import img4 from '../../images/img4.png';
import img5 from '../../images/img5.png';
import img6 from '../../images/img6.png';
import img7 from '../../images/img7.png';
import img8 from '../../images/img8.png';
import photo1 from './photo/1.jpeg';
import photo2 from './photo/2.jpeg';
import photo3 from './photo/3.jpeg';
import photo4 from './photo/4.jpeg';
import photo5 from './photo/5.jpeg';
import photo6 from './photo/6.jpeg';
import photo7 from './photo/7.jpeg';
import photo8 from './photo/8.jpeg';
import MediaQuery from "react-responsive";
import { API_BASE_URL } from '../../../config/api';
import FeatureBadges from './FeatureBadges';

const Block1 = () => {
    const defaultFirstRow = React.useMemo(() => [photo1, photo2, photo3, photo4], []);
    const defaultSecondRow = React.useMemo(() => [photo5, photo6, photo7, photo8], []);
    const [photos, setPhotos] = React.useState(defaultFirstRow);
    const [photos2, setPhotos2] = React.useState(defaultSecondRow);

    React.useEffect(() => {
        const toAbsoluteUrl = (url) => {
            if (!url) return null;
            if (url.startsWith('http://') || url.startsWith('https://')) return url;
            return `${API_BASE_URL}${url}`;
        };

        fetch(`${API_BASE_URL}/api/carousel-images/`)
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Failed to load carousel images');
                }
                return response.json();
            })
            .then((data) => {
                const first = (data.first || []).map(toAbsoluteUrl).filter(Boolean);
                const second = (data.second || []).map(toAbsoluteUrl).filter(Boolean);

                if (first.length) setPhotos(first);
                if (second.length) setPhotos2(second);
            })
            .catch(() => {
                setPhotos(defaultFirstRow);
                setPhotos2(defaultSecondRow);
            });
    }, [defaultFirstRow, defaultSecondRow]);

    return (
        <div className={classes._}>
            <img alt={'img2'} src={img2} className={classes.img} style={{ width: '234px', left: '30%' }} />
            <img alt={'img3'} src={img3} className={classes.img} style={{ width: '200px', left: '42%' }} />
            <img alt={'img4'} src={img4} className={classes.img} style={{ width: '180px', left: '52%' }} />
            <img alt={'img5'} src={img5} className={classes.img} style={{ width: '180px', left: '65%' }} />
            <img alt={'img6'} src={img6} className={classes.img} style={{ width: '160px', left: '77%' }} />
            <img alt={'img7'} src={img7} className={classes.img} style={{ width: '240px', right: '0', top: '20px' }} />
            <img alt={'img8'} src={img8} className={classes.img} style={{ width: '240px', right: '5%', bottom: '27px' }} />
            <div className={classes.fon2}></div>
            <div className={classes.block}>
                <div className={classes.blockLeft}>
                    <div className={classes.yandex}>
                        <iframe
                            title="Рейтинг Яндекс"
                            src="https://yandex.ru/sprav/widget/rating-badge/117473602162?type=rating"
                            width="150"
                            height="50"
                            frameBorder="0"
                            className={classes.ratingWidget}
                        />
                        <iframe
                            title="Рейтинг 2ГИС"
                            src="https://widget.2gis.ru/api/widget?org_id=70000001100647616&branch_id=70000001100647617&size=medium&theme=light"
                            width="150"
                            height="50"
                            frameBorder="0"
                            scrolling="no"
                            className={classes.ratingWidget}
                        />
                    </div>
                    <div className={classes.blockLeft1}>
                        <div className={classes.blockLeftText1}>Салон мужской эстетики</div>
                        <div className={classes.blockLeftText2}>Л.Е.В.</div>
                        <div className={classes.blockLeftText3}>Только мастерство, комфорт, атмосфера.</div>
                        <a
                            href="https://widget.sonline.su/ru/services/?placeid=852816903"
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes.button}
                        >
                            <svg xmlns="http://www.w3.org/2000/svg" width="40" height="45" viewBox="0 0 40 45" fill="none" className={classes.buttonIcon}>
                                <path fillRule="evenodd" clipRule="evenodd" d="M34.8024 33.2511C35.2379 32.6908 37.2318 27.8832 33.2087 24.8557C30.8475 23.0789 28.2276 23.4708 26.7807 24.1308C25.3339 24.7907 24.9505 25.2871 24.013 25.1923C23.166 25.1066 21.7785 23.6797 21.1538 23.2012C20.654 22.8183 12.1518 15.3183 7.88239 11.5727C5.85743 9.77704 1.67953 6.08342 1.16758 5.67396C0.527627 5.16213 -0.124892 5.78125 0.0202394 6.27766C0.165371 6.77407 1.86085 9.77823 3.32676 11.9226C4.79267 14.067 7.30963 17.1787 8.99394 18.8216C10.3414 20.136 11.7448 21.3176 12.2477 21.6776C12.2239 24.18 12.1642 29.319 12.1161 29.8553C12.0561 30.5256 11.8463 31.2241 11.0453 31.4287C10.2444 31.6333 7.81311 32.5414 6.70533 34.2121C5.59754 35.8828 4.9325 38.758 6.43997 41.205C8.00542 43.746 10.5996 44.5319 12.7418 44.2379C14.8841 43.9439 17.2474 42.2632 18.1322 39.5689C19.017 36.8747 17.3908 34.2006 16.8399 33.5276C16.289 32.8546 15.2012 31.9845 15.217 30.7717C15.2329 29.5588 15.635 26.9272 15.7839 26.1328C15.9733 25.1221 16.7908 24.5081 17.7118 25.0123C18.6328 25.5165 20.7089 26.8601 21.3977 27.3899C22.0865 27.9196 22.6558 28.544 22.7495 29.9078C22.8431 31.2716 23.481 33.4722 25.2089 34.8541C26.9367 36.2361 28.6283 36.4691 30.2725 36.2416C31.5878 36.0596 32.374 35.5911 32.6027 35.3796C33.1129 35.6961 34.4878 36.3041 35.9055 36.204C37.6776 36.0788 39.0855 35.1553 39.3593 34.508C39.6332 33.8607 38.9074 33.4282 38.5188 33.6456C38.1302 33.863 36.7856 34.0343 36.2757 33.9856C35.8677 33.9467 35.1235 33.4797 34.8024 33.2511ZM16.1285 21.2738C15.8687 20.7043 15.1951 20.4647 14.615 20.7184C14.0254 20.9762 13.7446 21.662 14.0086 22.2408C14.2726 22.8196 14.9746 23.057 15.5557 22.7808C16.1276 22.509 16.3882 21.8433 16.1285 21.2738ZM32.9844 28.3739C32.1103 26.3319 29.6408 25.4333 27.614 26.403C25.6238 27.3552 24.7652 29.7261 25.7164 31.689C26.6678 33.6524 29.0626 34.4489 31.0445 33.4784C32.9706 32.5351 33.8187 30.3231 32.9844 28.3739ZM15.6556 36.2781C14.7816 34.236 12.312 33.3375 10.2853 34.3072C8.29502 35.2594 7.43602 37.6305 8.38763 39.5932C9.31707 41.5102 11.5709 42.3175 13.5476 41.4593C15.5622 40.5845 16.51 38.2743 15.6556 36.2781Z" fill="#4F4230" fill-opacity="0.5"/>
                                <path d="M12.1424 14.0501C12.1077 10.6768 12.0383 3.76964 12.0378 3.12689C12.0372 2.32345 12.0095 1.3716 12.0022 0.731921C11.995 0.092241 12.9741 -0.434728 13.4141 0.529966C13.8542 1.49466 14.7685 4.21214 15.2276 5.93166C15.6868 7.65117 16.0311 8.94081 16.3286 10.5733C16.6261 12.2058 16.8926 15.0179 16.9302 15.7241C16.9602 16.2891 16.9497 17.6977 16.9406 18.3314L12.1424 14.0501Z" fill="#4F4230" fill-opacity="0.5"/>
                            </svg>
                            Записаться онлайн
                        </a>
                    </div>
                </div>
                <MediaQuery maxWidth={999}>
                    <FeatureBadges />
                </MediaQuery>
                <div className={classes.blockRight}>
                    <img src={img1} alt="img1" className={classes.img1}/>
                    <div className={classes.carouselWrap}>
                        <div className={classes.fon3}></div>
                        <div className={classes.fon4}></div>
                        <div className={classes.carouselRow}>
                            <div className={classes.carouselTrack}>
                                {photos.concat(photos).map((src, i) => (
                                    <img key={`row1-${i}`} src={src} alt="" className={classes.carouselImg} />
                                ))}
                            </div>
                        </div>
                        <div className={classes.carouselRow}>
                            <div className={`${classes.carouselTrack} ${classes.carouselTrackRight}`}>
                                {photos2.concat(photos2).map((src, i) => (
                                    <img key={`row2-${i}`} src={src} alt="" className={classes.carouselImg} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <MediaQuery minWidth={1000}>
                <FeatureBadges />
            </MediaQuery>
            <div className={classes.bottonBlock}></div>
        </div>
    );
};

export default Block1;